import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import escapeRegExp from 'lodash/escapeRegExp';
import memoize from 'lodash/memoize';
const splitter = memoize((s)=>{
    return new RegExp(`(${s.split(/\s+/).map(escapeRegExp).join('|')})`, 'ig');
});
const HighlightText = (props)=>{
    const { text, search } = props;
    if (!search || !text) {
        return text ? /*#__PURE__*/ _jsx(_Fragment, {
            children: text
        }) : null;
    }
    const filterPattern = splitter(search);
    const parts = text.split(filterPattern);
    return parts.length ? /*#__PURE__*/ _jsx(_Fragment, {
        children: parts.map((match, i)=>{
            return i % 2 === 0 ? match : /*#__PURE__*/ _jsx("mark", {
                "data-testid": "Mark",
                children: match
            }, i);
        })
    }) : null;
};
export default HighlightText;
